import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4fb596ab&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb596ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb596ab')) {
      api.createRecord('4fb596ab', component.options)
    } else {
      api.reload('4fb596ab', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4fb596ab&scoped=true&", function () {
      api.rerender('4fb596ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parse/3-35/index.vue"
export default component.exports